module.exports = __webpack_public_path__ + "img/servis-user.f74f2780.svg";